import { withSnackbar } from 'notistack';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import connect from 'react-redux/es/connect/connect';
import TablePage from '../../common/TablePage';
import * as Actions from "../../actions/Actions";
import strings from '../../localization';
import { TableRow, TableBody, TableCell, TableHead, TableFooter, Menu, ListItemIcon, ListItemText } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MoreVert from '@material-ui/icons/MoreVert';
import { MenuItem } from "@material-ui/core";
import ViewTombRent from '../tombRent/ViewTombRent';
import EditTombRent from '../tombRent/EditTombRent';
import ViewCassetteRent from '../cassetteRent/ViewCassetteRent';
import EditCassetteRent from '../cassetteRent/EditCassetteRent';
import ViewReservation from '../reservation/ViewReservation';
import EditReservation from '../reservation/EditReservation';


class RenewalProcessingResult extends TablePage {
    tableDescription = [
        { key: 'mainBookOfBuriedString', label: strings.leaseRenewalProcessingList.contractNumber, sort: 'mainBookOfBuriedString' },
        { key: 'dateOfChange', label: strings.leaseRenewalProcessingList.dateOfChange, transform: 'renderColumnDate', sort: 'dateOfChange' },
        { key: 'submitterNameSurname', label: strings.leaseRenewalProcessingList.submitterNameSurname, sort: 'submitterNameSurname' },
        { key: 'graveyardName', label: strings.leaseRenewalProcessingList.graveyardName, sort: 'graveyardName' },
        { key: 'graveSiteCode', label: strings.leaseRenewalProcessingList.graveSiteCode, sort: 'graveSiteCode' },
        { key: 'contractExpiryDate', label: strings.leaseRenewalProcessingList.contractExpiryDate, transform: 'renderColumnDate', sort: 'contractExpiryDate' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            data: {
                ...this.state.data,
                selectedRenewalType: { id: -1 },
            },
            selectedRenewalTypeKind: props.selectedRenewalTypeKind,
            showSearch: false,
            showAdd: false,
            responseData: [],
        };

        this.state.sortBy = "dateCreated,DESC";

    }

    fetchData() {
        this.setState({
            tableData: this.props.data,
            total: this.props.total,
        });
    }

    usePermissions(){
        let data = {
          userId: this.props.auth.user.id,
          category: "Обрада закупа"
        }
        this.getPermissionsS(data);
        this.showAdd(this.props.showAdd);
        this.showRemove(this.props.remove);
        this.showEdit(this.props.showEdit);
        this.showView(this.props.showView);
        this.removedItemsShow(this.props.removedItemsShow);
    
      }
    
      componentDidMount() {
        this.usePermissions()
        this.setState({
            companyId: this.props.auth.user.company.id,
        });

    }

    componentWillReceiveProps(nextProps) {
        strings.setLanguage(nextProps.auth.user.language);
        this.tableDescription = [
            { key: 'mainBookOfBuriedString', label: strings.leaseRenewalProcessingList.contractNumber, sort: 'mainBookOfBuriedString' },
            { key: 'dateOfChange', label: strings.leaseRenewalProcessingList.dateOfChange, transform: 'renderColumnDate', sort: 'dateOfChange' },
            { key: 'submitterNameSurname', label: strings.leaseRenewalProcessingList.submitterNameSurname, sort: 'submitterNameSurname' },
            { key: 'graveyardName', label: strings.leaseRenewalProcessingList.graveyardName, sort: 'graveyardName' },
            { key: 'graveSiteCode', label: strings.leaseRenewalProcessingList.graveSiteCode, sort: 'graveSiteCode' },
            { key: 'contractExpiryDate', label: strings.leaseRenewalProcessingList.contractExpiryDate, transform: 'renderColumnDate', sort: 'contractExpiryDate' },
        ];

        if (this.props.data !== nextProps.data || this.props.total !== nextProps.total) {
            this.setState({
                responseData: nextProps.data,
                tableData: nextProps.data,
                total: nextProps.total,
            });
        }
    }

    renderTableControls() {
        
    }

    onFinish(data, fetch) {
        this.props.onEditCompleted(data);
    }

    renderEditContent() {
        if (this.state.selectedRenewalTypeKind.id === 3) {
            return <EditTombRent
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={false}
                flag={"edit"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        } else if (this.state.selectedRenewalTypeKind.id === 4) {
            return <EditCassetteRent
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={false}
                flag={"edit"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        } else if (this.state.selectedRenewalTypeKind.id === 5) {
            return <EditReservation
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={false}
                flag={"edit"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        }
      }
    
    renderViewContent() {
        if (this.state.selectedRenewalTypeKind.id === 3) {
            return <ViewTombRent
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={true}
                flag={"view"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        } else if (this.state.selectedRenewalTypeKind.id === 4) {
            return <ViewCassetteRent
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={true}
                flag={"view"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        } else if (this.state.selectedRenewalTypeKind.id === 5) {
            return <ViewReservation
                id={this.state.selectedItem.id}
                uemail={this.props.auth.user.email}
                cid={this.state.companyId}
                onCancel={this.onCancel}
                onFinish={this.onFinish}
                isDisabled={true}
                flag={"view"}
                modifiedData={true}
                data={this.state.selectedItem}
                auth={this.props.auth}
            />
        }
    }

    getPageHeader() {
        if (this.state.selectedRenewalTypeKind.id === 3) {
            return <h2>{strings.leaseRenewalProcessingList.headerTitleTombRent}</h2>;
        } else if (this.state.selectedRenewalTypeKind.id === 4) {
            return <h2>{strings.leaseRenewalProcessingList.headerTitleCassetteRent}</h2>;
        } else if (this.state.selectedRenewalTypeKind.id === 5) {
            return <h2>{strings.leaseRenewalProcessingList.headerTitleArrangedPlot}</h2>;
        }
    }

    isRowSelected(item) {
        return this.state.selectedItem && item.indicator === this.state.selectedItem.indicator && item.id === this.state.selectedItem.id;
    }

    renderRowMenu(index, item) {

        let ariaOwns = 'action-menu-' + index;

        return (
            <TableCell>
                <IconButton
                    size='small'
                    aria-owns={this.state.anchorEl ? ariaOwns : undefined}
                    aria-haspopup="true"
                    onClick={(event) => this.handleMenuClick(event, ariaOwns)}
                >
                    <MoreVert />
                </IconButton>
                {
                    ariaOwns === this.state.ariaOwns &&
                    <Menu
                        id={ariaOwns}
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={() => this.handleMenuClose()}
                    >
                        <MenuItem onClick={() => this.handleMenuView(item)}>
                            <ListItemIcon>
                                <VisibilityIcon />
                            </ListItemIcon>
                            <ListItemText primary={strings.table.view} />
                        </MenuItem>
                        <MenuItem onClick={() => this.handleMenuEdit(item)}>
                            <ListItemIcon>
                                <EditIcon />
                            </ListItemIcon>
                            <ListItemText primary={strings.table.edit} />
                        </MenuItem>
                        <MenuItem onClick={() =>{ this.props.handleRemoveItemFromProcessingList(item); this.handleMenuClose(); }}>
                            <ListItemIcon>
                                <DeleteIcon />
                            </ListItemIcon>
                            <ListItemText primary={strings.table.delete} />
                        </MenuItem>
                    </Menu>
                }
            </TableCell>
        );
    }



    renderTableRow(data = []) {

        let result = [];

        for (let item of data) {

            let className = 'table-row-' + result.length % 2;

            // if (item.contractExpiryDate) {
            //     const today = new Date();
            //     const expiryDate = new Date(item.contractExpiryDate);
            //     if (expiryDate < today) {
            //         className += ' backgroundColorExpired';
            //     }
            // }

            if (this.isRowSelected(item)) {
                className += ' selected';
            }

            const today = new Date();
            const dateUpdated = new Date(item.dateEdited ? item.dateEdited : item.dateUpdated);
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 7);

            if (dateUpdated >= sevenDaysAgo && dateUpdated <= today) {
                className = 'backgroundColorEditedProcess';
            }

            result.push(
                <TableRow key={'table-row-' + result.length} className={className} onClick={() => this.selectRow(item)}>
                    {this.renderRowMenu(result.length, item)}
                    {this.renderTableRowData(item)}
                </TableRow>
            )
        }

        return (
            <TableBody>
                {result}
            </TableBody>
        );
    }

    renderTableHeader() {

        let result = [];

        for (let item of this.tableDescription) {

            result.push(
                <TableCell key={'table-header-' + result.length}>
                    <div className='container-horizontal'>
                        <div className='container-horizontal-label'>
                            {item.label}
                        </div>
                    </div>
                </TableCell>
            )
        }

        return (
            <TableHead className='table-header'>
                <TableRow>
                    <TableCell>
                        {strings.table.actions}
                    </TableCell>
                    {result}
                </TableRow>
            </TableHead>
        );
    }

    renderTableFooter() {
        return (
            <TableFooter>
                <TableRow>

                </TableRow>
            </TableFooter>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen
    }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
    return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers, };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenewalProcessingResult)));
